module.exports = __webpack_public_path__ + "static/media/leavers-2023.fef9bcae.png";